import styled from "styled-components";
import { black } from "../../utils/StyleHelpers";

export const StyledCircle = styled.div<any>`
  height: 16px;
  width: 16px;
  border: 1px solid ${black};
  border-radius: 16px;
  background-color: ${(props) => (props.color ? props.color : "")};
`;
